// API endpoint - Express API deployed on Vercel
const API_BASE_URL = process.env.REACT_APP_API_URL;

/**
 * Fetches all apps from the Google Play developer account via API
 * @returns {Promise<Array>} Array of app objects
 */
export const fetchDeveloperApps = async () => {

  try {
    const response = await fetch(`${API_BASE_URL}/api/apps`);
    

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error || 'Failed to fetch apps');
    }

    return data.data;
  } catch (error) {
    console.error('Error fetching apps from API:', error);
    throw error;
  }
};

/**
 * Fetches detailed information for a specific app
 * Note: Implement a separate API endpoint if needed
 * @param {string} appId - The app package name (e.g., 'com.example.app')
 * @returns {Promise<Object>} Detailed app information
 */
export const fetchAppDetails = async (appId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/app?id=${appId}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    if (!data.success) {
      throw new Error(data.error || 'Failed to fetch app details');
    }

    return data.data;
  } catch (error) {
    console.error(`Error fetching details for app ${appId}:`, error);
    throw error;
  }
};
